import React, { useState, useEffect } from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import Grid from "@bappweb/grid"
import Row from "@bappweb/row"
import Col from "@bappweb/col"
import "../assets/style.scss"

const LandingHeader = (props) => {

  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Block className="landing-header-text-wrapper">
        <Grid className="container">
          <Row>
            <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
              <Block className="landing-header-text">
                <Element type="h1" className="header-text1">{props.campaignHeaderText}</Element>
              </Block>
            </Col>
          </Row>
        </Grid>
      </Block>
      {props.cid === "girisimbank" ? (
        <Image path={"./img/kobiisbirlikleri/landing-header-girisimbank.png"} className="landing-header-img landing-header-img-desktop" />
      ) : <Image path={"./img/kobiisbirlikleri/landing-header.png"} className="landing-header-img landing-header-img-desktop" />
      }

    </Block>
  )
}

export default LandingHeader
